import type { FaireProductEntity } from "../../entity_types/product";

export const p_nash6r4j64: FaireProductEntity = {
  token: "p_nash6r4j64",
  type: "product",
  name: "Gut Love - Wholesale",
  brandToken: "b_7piiqmq04r",
  brandName: "Lake & Oak Tea Co.",
  imageUrl: "https://cdn.faire.com/fastly/91e946cc12bc95b74753b1c2efe2829e0733a110332f0e08da2e2adf82b1026c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e1dfd1055093d1b218f245a93d87bdaa7fa2b733dd5f4a1c0a31f31cf8afc1d7.png",
    "https://cdn.faire.com/fastly/f7bca39e407ded7bfc58252ff06cceca3cbaad6b7bbfaaf4f7aa25200a250a2a.jpeg"
  ],
  priceDollars: 9.8,
  description: "SUPERFOOD TEA BLEND\n\nShow a little love to your insides with this revitalizing cup of tea; your gut will thank you for it! Lemongrass, dandelion root and milk thistle are your superherb lineup, perfect as an everyday refresh and feel-good tonic. \n\n100% ORGANIC - ADAPTOGENIC - NUTRITIONIST FORMULATED \n\nHow to Enjoy:\n\n * Steep tea in 1 cup of 98° water for 4-6 minutes. \n * Try me with a squeeze of lemon. \n * Try me iced or cold-brewed for a hydrating and cleansing tonic. \nWhen to Steep:\n\n\n * A soothing, all-day, caffeine-free tea \n * To calm digestive trouble or soothe symptoms of IBS. \n * To promote natural detoxification and cleansing. \n * To calm your nerves and promote calmness and clarity. \n * To boost immunity and reduce inflammation with superfoods. \nCaffeine-free\n\n\n\n",
  tags: [],
  msrpDollars: 15.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:37.916Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
